const ShoppingCart = require('od-modules/cart/cart');
const InsuranceUtils = require('./insurance.utils');

const addProductToShoppingCart = () => {
    const {id, name, totalPrice = 0} = InsuranceUtils.getInsurance();

    ShoppingCart.builders.insurance.data({
        id,
        type: InsuranceUtils.getInsurancePolicy(),
        concept: name,
        price: {
            total: totalPrice,
        },
    }).fromAutomaticAddition().add();
};

const getId = () => InsuranceUtils.getInsuranceId();

const getPolicy = () => InsuranceUtils.getInsurancePolicy();

const getCartId = () => ShoppingCart.builders.insurance.id(getPolicy(), getId()).name;

const isProductAddedToShoppingCart = () => ShoppingCart.containsProduct(getCartId());

module.exports = {
    addProduct: () => !isProductAddedToShoppingCart() ? addProductToShoppingCart() : false,
};
